import script from "./office-list-item.vue?vue&type=script&lang=js"
export * from "./office-list-item.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__